module.exports = "/images/icometrix_logo.png?3fd53dd892b475d47fa919020f4af1e9";